import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { CHAT_FORM_FIELD_NAMES } from '../config';
import { ChatFormValues } from '../config/types/ChatForm';
import { useChatMessagesContext } from '../context/chatMessages';

export const useFocusOnParentChange = () => {
  const { parentMessage } = useChatMessagesContext();
  const { setFocus } = useFormContext<ChatFormValues>();

  useEffect(() => {
    setFocus(CHAT_FORM_FIELD_NAMES.TEXT);
  }, [setFocus, parentMessage]);
};
